import { Trans } from "@lingui/macro";
import { Button } from "@winamp/ui/components/Button/Button.js";
import type { ReactNode } from "react";
import { Link } from "react-router";
import { useUser } from "~/hooks/useUser";
import { Form } from "./Form";
import { Winamp } from "./Winamp";

export function AppErrorBoundary({
  children,
  title,
  message,
}: { children?: ReactNode; title: string; message?: string }) {
  const { user } = useUser();
  return (
    <div className="relative flex flex-col items-center text-primary font-sans antialiased w-screen min-h-screen">
      <main className="flex flex-1 items-center justify-center w-full -mt-4">
        <div className="relative flex flex-1 flex-col max-w-screen-xl p-4 md:pb-8">
          <div className="relative flex flex-1">
            <div className="flex flex-col gap-10 items-center lg:px-[60px] max-md:px-0 max-h-full w-full">
              <div className="flex flex-col bg-primary shadow-2xl rounded-lg p-8 gap-6 w-full lg:min-w-[--form-card-width-sm] max-w-[--form-card-width-sm] m-auto md:h-fit">
                <div className="flex flex-col gap-2">
                  <h2 className="font-bold text-2xl/7">{title}</h2>
                  {message && (
                    <p className="font-normal text-sm/5 text-secondary">
                      {message}
                    </p>
                  )}
                </div>
                {children}
                <div className="flex items-center justify-center">
                  <Button to="" reloadDocument>
                    <Trans>Retry</Trans>
                  </Button>
                </div>
              </div>
              <div className="mt-auto flex flex-col items-center gap-2 py-[40px]">
                {user && (
                  <div className="flex items-center justify-center gap-2">
                    {user?.email && (
                      <span className="text-xs/4 truncate">{user.email}</span>
                    )}
                    <Form method="post" action="/logout">
                      <Button size="2xs" variant="secondary" type="submit">
                        <Trans>Log out</Trans>
                      </Button>
                    </Form>
                  </div>
                )}
              </div>
              <Link to="" reloadDocument>
                <Winamp className="h-10" />
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
